/* LOADING */
const SHOW_LOADING = 'SHOW LOADING';
const HIDE_LOADING = 'HIDE LOADING';

/* POKEMONS */
const SEARCH_POKEMON = 'SEARCH POKEMON';
const GET_POKEMONS = 'GET POKEMONS OF API';
const GET_ALL_POKEMONS = 'GET ALL POKEMONS OF API';
const LEAVE_POKEMON = 'LEAVE POKEMON';
const CAPTURE_POKEMON = 'CAPTURE POKEMON';
const RENAME_POKEMON = 'RENAME POKEMON';
const ADD_FAVORITE_POKEMON = 'ADD POKEMON TO FAVORITES';
const DELETE_FAVORITE_POKEMON = 'DELETE POKEMON FROM FAVORITES';

/* ERRORS */
const ERROR_GETTING_ALL_POKEMONS = 'ERROR GETTING ALL POKEMONS';

export {
  SHOW_LOADING,
  HIDE_LOADING,
  SEARCH_POKEMON,
  GET_POKEMONS,
  GET_ALL_POKEMONS,
  LEAVE_POKEMON,
  CAPTURE_POKEMON,
  RENAME_POKEMON,
  ADD_FAVORITE_POKEMON,
  DELETE_FAVORITE_POKEMON,
  ERROR_GETTING_ALL_POKEMONS
}